module.exports = __webpack_public_path__ + "img/affe.caaddf67.png";